import styled from 'styled-components';
import { s } from './NPL.styles';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IExpectedInvestmentPeriodProps {
  expectedInvestmentPeriod: ReturnType<
    NplCalculation['getExpectedInvestmentDays']
  >;
}

const ExpectedInvestmentPeriod = (props: IExpectedInvestmentPeriodProps) => {
  const { expectedInvestmentPeriod } = props;
  return (
    <s.Div>
      <s.Title>예상 투자기간</s.Title>
      <div>
        <Table>
          <s.DivRow backgroundColor="#F2F7FF" position="top">
            <s.LeftCell>(예상) 양도, 양수 계약일</s.LeftCell>
            <s.RightCell>
              {expectedInvestmentPeriod.row1_1
                .split(' ')[0]
                .replaceAll('-', '.')}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow backgroundColor="#F2F7FF">
            <s.LeftCell>(예상) 낙찰일</s.LeftCell>
            <s.RightCell>
              {expectedInvestmentPeriod.row2_1
                .split(' ')[0]
                .replaceAll('-', '.')}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>(예상) 배당기일</s.LeftCell>
            <s.RightCell>
              {expectedInvestmentPeriod.row1_2
                .split(' ')[0]
                .replaceAll('-', '.')}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow position="bottom">
            <s.LeftCell>(예상) 투자기간</s.LeftCell>
            <s.RightCell>{expectedInvestmentPeriod.row2_2}</s.RightCell>
          </s.DivRow>
        </Table>
        <s.BlueSmallText>*예상 투자기간은 변경될 수 있음</s.BlueSmallText>
      </div>
    </s.Div>
  );
};

export default ExpectedInvestmentPeriod;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;
